module.exports = __webpack_public_path__ + "images/emoji/ru.bd1e4563a72cad664c9e.png";